import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ME_QUERY_KEY } from "@/auth/AuthContext";
import { verificationService } from "@/services/verificationService";

export function useSendEmailVerification() {
  return useMutation({ mutationFn: () => verificationService.sendEmail() });
}

export function useConfirmEmailVerification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (token: string) => verificationService.confirmEmail(token),
    onSuccess: () => qc.invalidateQueries({ queryKey: ME_QUERY_KEY }),
  });
}

export function useSendPhoneVerification() {
  return useMutation({ mutationFn: () => verificationService.sendPhone() });
}

export function useConfirmPhoneVerification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (code: string) => verificationService.confirmPhone(code),
    onSuccess: () => qc.invalidateQueries({ queryKey: ME_QUERY_KEY }),
  });
}
